import * as AT from "./actionTypes";
import * as MT from "./mutationTypes";
import api from "@/packages/api";
import Auth from "@/packages/auth";

export default {
  [AT.LOGIN]: (context, data) => {
    return api
      .login(data)
      .then(response => {
        return response;
      })
      .catch(error => context.dispatch(AT.LOGIN_USER_ERROR, error.response.data));
  },
  [AT.LOGIN_USER_ERROR]: (context, data) => {
    context.commit(MT.SET_LOGIN_ERROR, data);
  },
  [AT.GET_USER]: context => {
    context.commit(MT.GET_USER);
  },
  [AT.GET_ACCOUNT]: context => {
    context.commit(MT.GET_ACCOUNT);
  },
  [AT.FORGOT_PASSWORD]: (context, data) => {
    return api
      .forgotPassword(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.SHOPIFY_INSTALL_APP]: (context, data) => {
    return api
      .shopifyInstallApp(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.CHECK_REGISTER_PAGE]: (context, data) => {
    return api
      .checkRegistrationPage(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },

  [AT.SAVE_EMAIL_SETTINGS]: (context, data) => {
    return api
      .updateEmail(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.FETCH_EMAIL_SETTINGS]: () => {
    return api
      .getEmailSettings()
      .then(response => {
        return response;
      })
      .catch(error => error);
  },
  [AT.SAVE_PDF_EMAIL_SETTINGS]: (context, data) => {
    return api
      .updatePDFEmail(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.FETCH_PDF_SETTINGS]: (contect, data) => {
    return api
      .getPDFEmailSettings(data)
      .then(response => {
        return response;
      })
      .catch(error => error);
  },
  [AT.REGISTER]: (context, data) => {
    return api
      .register(data)
      .then(response => {
        // Auth.setToken(response.token);
        // context.commit(MT.SET_USER, response.user);
        return response;
      })
      .catch(error => context.commit(MT.SET_REGISTRATION_ERROR, error.response.data));
  },
  [AT.GET_PENDING_ORDERS]: (context, data) => {
    return api
      .getPendingOrders(data)
      .then(response => {
        context.commit(MT.STORE_PENDING_ORDERS_DATA, response);
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.CUSTOMER_FILTER]: (context, data) => {
    return context.commit(MT.CUSTOMER_FILTER, data);
  },
  [AT.COMPANY_FILTER]: (context, data) => {
    return context.commit(MT.COMPANY_FILTER, data);
  },
  [AT.STATUS_FILTER]: (context, data) => {
    return context.commit(MT.STATUS_FILTER, data);
  },
  [AT.STORE_LOADER]: (context, data) => {
    return context.commit(MT.STORE_LOADER, data);
  },
  [AT.DATE_FILTER]: (context, data) => {
    return context.commit(MT.DATE_FILTER, data);
  },
  [AT.GET_CUSTOMER_DETAILS]: (context, customerId) => {
    return api
      .getCustomerDetails(customerId)
      .then(response => {
        context.commit(MT.STORE_CUSTOMER_DETAILS, response);
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.PAYMENT_AFTER_CARD_VALIDATION]: (context, orderRefId) => {
    return api
      .paymentAfterCardValidation(orderRefId)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.MULTIPLE_PAYMENT_AFTER_CARD_VALIDATION]: (context, hash) => {
    return api
      .multiplePaymentAfterCardValidation(hash)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.PAYMENT_CARD_LIST]: (context, orderRefId) => {
    return api
      .paymentCardList(orderRefId)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.MULTIPLE_PAYMENT_CARD_LIST]: (context, hash) => {
    return api
      .multiplePaymentCardList(hash)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.PAYMENT_WITH_SAVED_CARD]: (context, data) => {
    return api
      .paymentWithSavedCard(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.MULTIPLE_PAYMENT_WITH_SAVED_CARD]: (context, data) => {
    return api
      .multiplePaymentWithSavedCard(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  [AT.STORE_ORDER]: (context, data) => {
    return api
      .storeOrder(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.UPDATE_ORDER]: (context, data) => {
    return api
      .updateOrder(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DELETE_ORDER]: (context, data) => {
    return api
      .deleteOrder(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ENABLE_MULTIPLE_ORDERS]: (context, data) => {
    return api
      .storeMultipleOrders(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DELETE_MULTIPLE_ORDERS]: (context, data) => {
    return api
      .deleteMultipleOrder(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.SELECT_PAYMENT_TERM]: (context, data) => {
    return api
      .handleTags(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_EMAIL_CADENCE_FOR_ORDER]: (context, data) => {
    return api
      .getEmailCadenceForOrder(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.RESEND_INVOICE]: (context, data) => {
    return api
      .resendInvoice(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.RESEND_STATEMENT]: (context, data) => {
    return api
      .resendStatement(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_PLANS]: (context, data) => {
    return api
      .getPlans(data)
      .then(response => {
        context.commit(MT.STORE_PLANS, response);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.SUBSCRIBE_PLAN]: (context, data) => {
    return api
      .subscribeTo(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.UPDATE_USER]: (context, user) => {
    Auth.setUser(user);
    context.commit(MT.UPDATE_USER, user);
    return;
  },
  [AT.VERIFY_TOKEN]: (context, data) => {
    return api
      .verifyToken(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.VERIFY_SUBDOMAIN]: (context, data) => {
    return api
      .verifySubdomain(data)
      .then(response => {
        if (response.redirectUrl === undefined) {
          Auth.setToken(response.token);
          Auth.setUser(response.user);
          Auth.setAccount(response.user.account.data);
          context.commit(MT.SET_USER, response.user);
          context.commit(MT.STORE_ACCOUNT_DETAILS, response.user.account);
        }

        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.RESET_PASSWORD]: (context, data) => {
    return api
      .resetPassword(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DOWNLOAD_INVOICE]: (context, data) => {
    return api
      .downloadInvoice(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DOWNLOAD_CUSTOMER_INVOICE]: (context, data) => {
    return api
      .downloadCustomerInvoice(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ORDERS_MANIPULATED]: (context, data) => {
    return context.commit(MT.ORDERS_MANIPULATED, data);
  },
  [AT.GET_REMAINING_ORDERS_ALLOWED_TO_ENABLE]: (context, data) => {
    data;
    return api
      .getRemainingOrdersAllowedToEnableDetails()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ONBOARDING_VERIFIED]: context => {
    return api
      .onboardingVerified()
      .then(response => {
        return context.commit(MT.ONBOARDING_VERIFIED, response);
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CHECK_WEBHOOKS]: () => {
    return api
      .checkWebhooks()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CHECK_SHOP_REGISTRATION]: (context, data) => {
    return api
      .checkShopRegistration(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CHECK_STRIPE_CONNECTION]: (context, data) => {
    return api
      .checkStripeConnection(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CUSTOMER_CHECKOUT]: (context, data) => {
    return api
      .customerCheckout(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.MULTIPLE_CUSTOMER_CHECKOUT]: (context, data) => {
    return api
      .multipleCustomerCheckout(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_ACCOUNT_DETAILS_FOR_CUSTOMER_CHECKOUT]: (context, data) => {
    return api
      .getAccountDetailsForCustomerCheckout(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.MARK_ORDER_AS_PAID]: (context, data) => {
    return api
      .markOrderAsPaid(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.MARK_MULTIPLE_ORDERS_AS_PAID]: (context, data) => {
    return api
      .markMultipleOrdersAsPaid(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ASSOCIATE_STRIPE_ACCOUNT]: (context, data) => {
    return api
      .associateStripeAccount(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_ACCOUNT_DETAILS]: context => {
    return api
      .getAccountDetails()
      .then(response => {
        context.commit(MT.STORE_ACCOUNT_DETAILS, response);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.UPDATE_ACCOUNT_DETAILS]: (context, data) => {
    return api
      .updateAccountDetails(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING]: () => {
    return api
      .enableSendInvoiceOnPendingOrderCreationSetting()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING]: () => {
    return api
      .disableSendInvoiceOnPendingOrderCreationSetting()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ADD_CUSTOM_NET_TERM]: (context, data) => {
    return api
      .addCustomNetTerm(data)
      .then(response => {
        context.commit(MT.ADD_CUSTOM_NET_TERM, response);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_CUSTOM_NET_TERM]: (context, data) => {
    return api
      .removeCustomNetTerm(data)
      .then(response => {
        context.commit(MT.REMOVE_CUSTOM_NET_TERM, data);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (context, data) => {
    return api
      .addEmailInMultipleEmailAddress(data)
      .then(response => {
        context.commit(MT.ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS, response);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (context, data) => {
    return api
      .removeEmailInMultipleEmailAddress(data)
      .then(response => {
        context.commit(MT.REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS, data);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS]: (context, data) => {
    return api
      .toggleStatusOfEmailInMultipleEmailAddress(data)
      .then(response => {
        context.commit(MT.ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS, data);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING]: () => {
    return api
      .calculateNetPaymentDaysFromFulfillmentDateSetting()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING]: () => {
    return api
      .removeCalculateNetPaymentDaysFromFulfillmentDateSetting()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.SAVE_LOGO]: (context, data) => {
    return api
      .saveLogo(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_LOGO]: () => {
    return api
      .removeLogo()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_ACCEPT_NEW_SCOPE_AUTH_URL]: context => {
    return api
      .getAcceptNewScopeAuthUrl()
      .then(response => {
        context.commit(MT.SET_NEW_SCOPE_ACCEPTED);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.NEW_SCOPES_ACCEPTED]: (context, data) => {
    return api
      .newScopesAccepted(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.STATEMENT_FOR_CUSTOMERS]: (context, data) => {
    return api
      .statementForCustomers(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_STATEMENT_FOR_CUSTOMERS]: (context, data) => {
    return api
      .removeStatementForCustomers(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.UPDATE_STATEMENT_DAYS]: (context, data) => {
    return api
      .updateStatementDays(data)
      .then(response => {
        context.commit(MT.RESET_ACCOUNT_FRONTEND);
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ADD_PERIODIC_UPDATES]: () => {
    return api
      .addPeriodicUpdates()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.REMOVE_PERIODIC_UPDATES]: () => {
    return api
      .removePeriodicUpdates()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DELETE_STRIPE_CONNECTION]: () => {
    return api
      .deleteStripeConnection()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_ORDER_REMINDER_EMAIL_PREVIEW]: (context, orderRefId) => {
    return api
      .getOrderReminderEmailPreview(orderRefId)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_ORDER_STATEMENT_REMINDER_EMAIL_PREVIEW]: (context, data) => {
    return api
      .getOrderStatementReminderEmailPreview(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_BILLING_ADDRESSES_OF_CUSTOMER]: (context, customerRefId) => {
    return api
      .getBillingAddressesOfCustomer(customerRefId)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ADD_BILLING_ADDRESS_FOR_CUSTOMER]: (context, data) => {
    return api
      .addBillingAddressForCustomer(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DELETE_BILLING_ADDRESS_OF_CUSTOMER]: (context, data) => {
    return api
      .deleteBillingAddressOfCustomer(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CUSTOMER_SCREEN_CREATE_REQUEST]: (context, customerRefId) => {
    return api
      .createRequest(customerRefId)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CUSTOMER_SCREEN_REQUEST_STATUS]: (context, data) => {
    return api
      .getRequestStatus(data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.CUSTOMER_SCREEN_DEACTIVATE_REQUEST]: () => {
    return api
      .deactivateRequest()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL]: () => {
    return api
      .enableSendStripePaymentLinkInEmail()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL]: () => {
    return api
      .disableSendStripePaymentLinkInEmail()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL]: () => {
    return api
      .enableSendShopifyCheckoutPaymentLinkInEmail()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL]: () => {
    return api
      .disableSendShopifyCheckoutPaymentLinkInEmail()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  [AT.GET_PLANS_PRICES]: () => {
    return api
      .getPlansPrices()
      .then(response => {
        return response;
      })
      .catch(error => {
        return Promise.reject(error.response);
      });
  }
};
